import script from "./Filter.vue?vue&type=script&setup=true&lang=js"
export * from "./Filter.vue?vue&type=script&setup=true&lang=js"

import "./Filter.vue?vue&type=style&index=0&id=bb454760&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb454760"]])

export default __exports__